// Exports collections names.
export const BILLING_REF = 'billing'
export const INVITES_REF = 'invites'
export const ISSUES_REF = 'issues'
export const LINES_REF = 'lines'
export const TRIALS_REF = 'trials'
export const USER_REF = 'users'